import React from 'react'

const Logo = () => (
  <svg
    width="152"
    height="43"
    viewBox="0 0 152 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.24823 0H6.69521C2.303 0 0 2.49787 0 7.26533V34.9028C0 39.6699 2.303 42.1682 6.69521 42.1682H8.24823C12.587 42.1682 14.89 39.6703 14.89 34.9028V7.26533C14.89 2.49787 12.587 0 8.24823 0ZM8.48013 33.9039C8.48013 34.5514 8.25791 34.8466 7.92373 34.8466H6.96752C6.6889 34.8466 6.41028 34.5514 6.41028 33.9039V8.26464C6.41028 7.67507 6.68848 7.32117 6.96752 7.32117H7.92373C8.25791 7.32117 8.48013 7.67507 8.48013 8.26464V33.9035V33.9039Z"
      fill="#DF1D3F"
    />
    <path
      d="M25.9389 31.0717C25.9389 32.0866 25.9587 33.0744 25.3821 33.8857H24.4246C23.8493 33.0744 23.869 32.0866 23.869 31.0717V0.227295H17.2988V21.1118C17.2988 30.6464 17.9945 35.243 22.4936 40.9186L23.2967 41.9405H26.7242L27.5285 40.9186C32.0276 35.243 32.5091 30.6468 32.5091 21.1118V0.227295H25.9389V31.0717Z"
      fill="#DF1D3F"
    />
    <path
      d="M41.9873 23.3833H43.8619V16.345H41.9873V7.26583H44.2903V0.227539H34.918V41.9412H44.3977V34.9029H41.9873V23.3833Z"
      fill="#DF1D3F"
    />
    <path
      d="M55.1464 0.227705H46.7383V41.941H53.3085V23.1597H54.8215C55.1561 23.1597 55.3783 23.5132 55.3783 24.102V41.941H61.7882V24.4037C61.7882 22.3037 61.1455 20.7156 59.9136 19.6938C61.1451 18.6719 61.7882 17.0838 61.7882 14.9838V7.49139C61.7882 2.72516 59.4852 0.227295 55.1464 0.227295V0.227705ZM55.3783 15.1759C55.3783 15.7647 55.1565 16.1182 54.8215 16.1182H53.3085V7.266H54.8215C55.1561 7.266 55.3783 7.61949 55.3783 8.20824V15.1759Z"
      fill="#DF1D3F"
    />
    <path
      d="M132.237 0.249512H125.168V41.9628H134.648V34.9249H132.237V0.249512Z"
      fill="#DF1D3F"
    />
    <path
      d="M145.357 0.249268H136.949V41.9625H145.357C149.696 41.9625 151.999 39.4646 151.999 34.6976V7.51337C151.999 2.74714 149.696 0.249268 145.357 0.249268ZM145.509 33.9824C145.509 34.5711 145.286 34.9246 144.953 34.9246H143.439V7.28632H144.953C145.286 7.28632 145.509 7.64105 145.509 8.2298V33.9824Z"
      fill="#DF1D3F"
    />
    <path
      d="M116.064 0.248868H110.14V0.248047H103.125C105.776 0.866766 107.314 2.77301 107.655 5.88467H107.656V36.3259H107.655C107.314 39.4376 105.776 41.3438 103.125 41.9625H114.226V23.1813H115.739C116.073 23.1813 116.296 23.5348 116.296 24.1235V41.9625H122.705V24.4253C122.705 22.3253 122.062 20.7372 120.831 19.7153C122.062 18.6934 122.705 17.1054 122.705 15.0053V7.51297C122.705 2.74674 120.402 0.248868 116.064 0.248868ZM116.296 15.1971C116.296 15.7858 116.073 16.1393 115.739 16.1393H114.226V7.28716H115.739C116.073 7.28716 116.296 7.64065 116.296 8.2294V15.1971Z"
      fill="#DF1D3F"
    />
    <path
      d="M85.0823 0.249312H81.0327V31.0937C80.8189 32.1086 80.8391 33.0964 80.2625 33.9077H79.486C78.9094 33.0964 78.9292 32.1086 78.9292 31.0937V0.249312H72.8299V31.0937C72.8299 32.1086 72.8497 33.0964 72.2744 33.9077H71.3169C70.7403 33.0964 70.7601 32.1086 70.7601 31.0937V0.249312H64.2168V21.1339C64.2168 30.6684 64.9668 35.2088 69.1974 40.8832L70.0017 41.9626H73.3219L74.1249 40.8832C74.8749 39.9188 75.4637 38.9544 75.9995 38.0458C76.5353 39.0102 77.1779 39.9184 77.8741 40.8832L78.6771 41.9626H81.9986L82.8016 40.8832C86.9792 35.3221 87.568 30.6684 87.568 21.1339V5.87937C87.9093 2.76894 89.4472 0.863104 92.0978 0.244385H85.0823V0.248901V0.249312Z"
      fill="#DF1D3F"
    />
    <path
      d="M98.5047 16.7102L97.6107 5.51904L96.7168 16.7102C96.6865 17.0904 96.6145 17.4656 96.4992 17.8298C96.3035 18.4481 95.9323 19.3349 95.2871 19.9643C95.9323 20.5937 96.3035 21.4805 96.4992 22.0988C96.6145 22.463 96.6865 22.8387 96.7168 23.2184L97.6107 38.0398L98.5047 23.2188C98.535 22.8387 98.6069 22.4634 98.7223 22.0992C98.918 21.4809 99.2892 20.5941 99.9344 19.9647C99.2892 19.3353 98.918 18.4485 98.7223 17.8302C98.6069 17.466 98.535 17.0904 98.5047 16.7106V16.7102Z"
      fill="#DF1D3F"
    />
  </svg>
)

export default Logo
